import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import logo from "@/assets/logo.png";

const Footer = () => (
  <footer aria-label="Site footer" className="border-t border-border bg-card/50 pb-20 md:pb-0">
    <div className="container py-16">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <Link to="/" className="flex items-center gap-2 mb-4">
            <img src={logo} alt="Modern Car Rentals logo" className="h-8 w-auto" width={46} height={32} />
          </Link>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Premium all-electric Tesla fleet rentals. Experience the future of driving today.
          </p>
          <div className="flex gap-4 mt-6">
            <a href="https://www.instagram.com/moderncarrentals" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-muted-foreground hover:text-primary transition-colors">
              <Instagram className="h-5 w-5" />
            </a>
            <a href="https://www.facebook.com/moderncarrentals" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-muted-foreground hover:text-primary transition-colors">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="https://www.tiktok.com/@moderncarrentals" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-muted-foreground hover:text-primary transition-colors">
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V9.22a8.16 8.16 0 0 0 4.77 1.53V7.3a4.85 4.85 0 0 1-1.01-.61z"/></svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Quick Links</h3>
          <div className="flex flex-col gap-2">
            {[
              { label: "Home", path: "/" },
              { label: "Book Online", path: "/#booking" },
              { label: "FAQ", path: "/faq" },
              { label: "Contact", path: "/contact" },
            ].map((link) => (
              <Link key={link.path} to={link.path} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Company */}
        <div>
          <h3 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Company</h3>
          <div className="flex flex-col gap-2">
            {[
              { label: "About Us", path: "/about" },
              { label: "Blog", path: "/blog" },
              { label: "Rideshare", path: "/rideshare" },
            ].map((link) => (
              <Link key={link.path} to={link.path} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Contact</h3>
          <div className="flex flex-col gap-3 text-sm text-muted-foreground">
            <a href="tel:+12015892177" className="flex items-center gap-2 hover:text-primary transition-colors">
              <Phone className="h-4 w-4" /> (201) 589-2177
            </a>
            <a href="mailto:info@moderncarrental.com" className="flex items-center gap-2 hover:text-primary transition-colors">
              <Mail className="h-4 w-4" /> info@moderncarrental.com
            </a>
            <span className="flex items-center gap-2">
              <MapPin className="h-4 w-4" /> Bayonne, NJ
            </span>
          </div>
        </div>
      </div>

      <div className="border-t border-border mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Modern Car Rentals. All rights reserved.</span>
        <a
          href="https://misolutions.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
        >
          Powered by MiSolutions.ai
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
